/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	initializeControls,
	type BscInitializationResult,
} from '@atlassian/browser-storage-controls/cookie-controls';
import { removeLegacyTimestampNamespaceKeys } from '@jira/platform__browser-storage-providers/src/removeLegacyTimestampNamespaceKeys.tsx';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';

import { shouldEnforceKeyForRollout } from '../rollout-enforcement/shouldEnforceKeyForRollout.tsx';

function isWebStorageEnforcedGateEnabled(isSpa?: boolean): boolean {
	return globalThis?.__SPA__ || isSpa
		? fg('jfp-vulcan-browser-storage-enabled')
		: fg('jfp-vulcan-browser-storage-enabled-legacy');
}

function isIndexedDbEnforcedGateEnabled(isSpa?: boolean): boolean {
	return globalThis?.__SPA__ || isSpa
		? fg('jfp-vulcan-indexeddb-enabled')
		: fg('jfp-vulcan-indexeddb-enabled-legacy');
}

let initializeControlsPromise: Promise<BscInitializationResult | undefined> | null = null;

export function initControlsOnce({
	userId,
	cloudId,
	isSpa,
}: {
	userId: string | undefined;
	cloudId: string | undefined;
	// isSpa is used in the early script when __SPA__ is not yet set
	isSpa?: boolean;
}): Promise<BscInitializationResult | undefined> {
	if (!initializeControlsPromise) {
		if (fg('jfp-vulcan-browser-storage-disable-auto-cleanup')) {
			removeLegacyTimestampNamespaceKeys();
		}
		initializeControlsPromise = initializeControls({
			product: 'Jira',
			webStorageEnabled:
				fg('jfp-vulcan-browser-storage-analytics-enabled') ||
				isWebStorageEnforcedGateEnabled(isSpa),
			disableWebStorageConsentChecks:
				fg('jfp-vulcan-browser-storage-analytics-enabled') &&
				!isWebStorageEnforcedGateEnabled(isSpa),
			indexedDbEnabled:
				fg('jfp-vulcan-indexeddb-analytics-enabled') || isIndexedDbEnforcedGateEnabled(isSpa),
			disableIndexedDbConsentChecks:
				fg('jfp-vulcan-indexeddb-analytics-enabled') && !isIndexedDbEnforcedGateEnabled(isSpa),
			perimeter: isFedRamp() ? 'fedramp-moderate' : 'commercial',
			userId,
			cloudId,
			allowUncategorizedItemsInWebStorageOverrides: isWebStorageEnforcedGateEnabled(isSpa),
			__UNSAFE_shouldEnforceKeyForRollout: shouldEnforceKeyForRollout,
		});
	}
	return initializeControlsPromise;
}

autoBeforeEachTest(() => {
	initializeControlsPromise = null;
});
